

export const businesses = [
  // Salony krásy a péče
  "Kadeřnictví",
  "Barber shop",
  "Kosmetika",
  "Masáže",
  "Tetování",
  "Piercing",
  "Manikúra a pedikúra",
  "Manikúra",
  "Pedikúra",
  "Výživové poradenství",
  "Osobní trenér",
  "Finanční poradenství",
  "Koučink",
  "Image poradenství",
  "Energetické léčení",
  "Hypnoterapie",
  "Privátní sauna",
  "Privátní wellness",
  "Privátní vířivka",
  "Pedikúra",
  "Solárium",
  "Restaurace",
  "Pizzerie",
  "Fast food",
  "Kavárna",
  "Cukrárna",
  "Bar",
  "Vinárna",
  "Čajovna",
  "Bistro",
  "Hospoda",
  "Hudební klub",
  "Herna (arcade)",
  "Grill bar",
  "Steakhouse",
  "Burger bar",
  "Veganská restaurace",
  "Sushi bar",
  "Café bar",
  "Tapas bar",
  "Koktejlový bar",
  "Pivovar",
  "Shisha bar",
  "Gaming bar",
  "Desková kavárna",
  "Tematický bar",
  "Únikovka",
  "Paintball",
  "Laser game",
  "Bowling",
  "Fotografické studio",
  "Ateliér",
  "Fotograf",
  "Taneční studio",
  "Zábavní park",
  "dětský koutek",
  "Chata",
  "Chalupa",
  "Rekreační objekt",
  "Apartmán",
  "Mobilní dům",
  "Tiny house",
  "Glamping",
  "Jurta",
  "Teepee",
  "Maringotka",
  "Karavan",
  "Obytný vůz",
  "Houseboat",
  "Hodinový hotel",
  "Údržba domácnosti",
  "Hodinový manžel",
  "Psí salón",
  "Fitness centrum",
  "Posilovna",
  "Jógové studio",
  "Pilates studio",
  "Taneční sál",
  "Sportovní hala",
  "Cvičební sál",
  "Wellness centrum",
  "Spinning centrum",
  "Bojová tělocvična",
  "Pohybové studio",
  "Multifunkční sál",
  "Pronájem sálu",
  "Rekreační centrum",
  "Komunitní centrum",
  "Kulturní dům",
  "Kurzy v přírodě",
];
  

  export const states = [
    { name: "Česko", language: "cs" },
    { name: "Slovensko", language: "sk" },
    { name: "Německo", language: "de" },
    { name: "Rakousko", language: "de" },
    { name: "Polsko", language: "pl" },
];
